export default __webpack_public_path__ + "static/media/skating.456a0c1a.png";